export default (id) => new Buffer(id, 'base64').toString().split(':')[1];
